<div class="tile" *ngIf="data">
  <div class="square-indicator">
    {{ data.value }} <br />
    SENT
  </div>
  <div class="tile-body">
    {{ data.label }}
  </div>
</div>
